import { Component, OnInit } from '@angular/core';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import {saveAs} from 'file-saver';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';



@Component({
  selector: 'ngx-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';
  isUploaded = false;

  refNo : string;
  description : string;
  attachmentList?: any=[];


  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 
 

         constructor(
              private fileUploadService:FileUploadService,
              private authService: AuthService,
              private router : Router, 
              private toastr: ToastrService,
              public dialogRef: MatDialogRef<FileUploadComponent>
             ){}


    ngOnInit() {
      this.refNo =  this.fileUploadService.refNo;
      this.getFiles();
      this.getControlPermissions();
    }

    getControlPermissions(){
      var data = [];
       data =  this.authService.controlPermissionArray.filter((el)=>{
        return el.moduleCode ==='FILE'
      });
      if(data.length > 0){
        this.crud_access.read = data[0].read;
        this.crud_access.create = data[0].create;
        this.crud_access.approve = data[0].approve;
        this.crud_access.delete = data[0].delete;
      }
    }

    getFiles(){
      this.fileUploadService.getFiles().
      subscribe(
         (data)=> {
           this.attachmentList =data.filter((el)=>{
            return el.RefNo ===this.refNo;
          }); ;
         },
         (err) => 
         {
           if(err instanceof HttpErrorResponse){                 
             if(err.status == 401){
               this.router.navigate(['/login']);
             }
           }
           console.log(err);
         });       
     
   }



    selectFile(event: any): void {
      this.currentFile = undefined;
      this.selectedFiles = event.target.files;
    }

    upload(): void {
      this.progress = 0;
      const formData  = new FormData();         
    
      if (this.selectedFiles && this.description) {
        const file: File | null = this.selectedFiles.item(0);
    
        if (file) {
          this.currentFile = file;
          formData.append('refNo',this.refNo);
          formData.append('file', this.currentFile, this.currentFile.name);
          formData.append('description',this.description);
          formData.append('attachedDate', moment().format("YYYY-MM-DD"));
          formData.append('createdBy',this.authService.getUserLoggedIn());
        
    
          this.fileUploadService.upload(formData).subscribe(
            (event: any) => {
              if (event.type === HttpEventType.UploadProgress) {
                this.progress = Math.round(100 * event.loaded / event.total);
              } else if (event instanceof HttpResponse) {
                this.message = event.body.message;
                this.isUploaded =event.body.uploaded;
                this.toastr.success('File uploaded successfully','Success');
               this.getFiles();
              }
            },
            (err: any) => {
              console.log(err);
              this.progress = 0;
    
              if (err.error && err.error.message) {
                this.message = err.error.message;
              } else {
                this.message = 'Could not upload the file!';
              }
    
              this.currentFile = undefined;
            });
        }
    
        this.selectedFiles = undefined;
      }
    }


     downloadBtnClick(item){
      this.fileUploadService.downloadFile(item.FileName)
      .toPromise()
       .then(blob => {
        saveAs(blob, item.FileName);
       })
       .catch(err => console.error("download error = ", err))
     }


     
    deleteBtnClick(item){
      this.fileUploadService.deleteFile(item.FileName)
      .subscribe(
        data =>{
          this.toastr.success('File deleted successfully','Success');
          this.getFiles();
        },
        err =>{
          console.log(err);
          this.toastr.error('Failed to delete file','Error');
        }
      );
     }


  onClose(){
    this.dialogRef.close();
   }

}